export const GET_SPEND_AMOUNT_ENDPOINT = '/Order/GetLevelSpentAmountMember ';

export const GET_DISPLAY_STATUS_MEMBER_LOYALTY_ENDPOINT = '/Account/GetStatusDisplayMemberLoyalty';
